import Immutable from 'seamless-immutable';
import RedeemActions from '../actions/RedeemActions';
import RedeemSource from '../sources/RedeemSource';
import {alt} from 'epic-react-common';
import {datasource} from 'alt-utils/lib/decorators';
import {getLocale} from '@epic-core/common';
import root from 'window-or-global';
import {seamlessImmutable} from 'epic-alt-utils';
import startTalon from '../utils/talon';

@datasource(RedeemSource)
@seamlessImmutable
class RedeemStore {
  constructor() {
    this.on('error', (error) => {
      console.error(error);
    });
    this.state = Immutable({
      currentStage: 'VALIDATE',
      redeemComplete: false,
      nextStage: '',
      redeemCode: '',
      title: '',
      description: '',
      isInvalidCode: null,
      validationError: null,
      requireEula: false,
      redeemError: null,
      loading: false,
      entitlementName: [],
    });
    this.bindActions(RedeemActions);
  }

  startCaptcha(talonFlowId, callback) {
    startTalon({
      flow: talonFlowId,
      onSuccess: (captchaToken) => {
        if (captchaToken) {
          this.setState(
            this.state.merge({
              captchaToken,
            })
          );
          callback();
        } else {
          callback();
        }
      },
      onFailed: () => {
        this.setState(
          this.state.merge(
            {
              confirmError: {message: 'errors.com.epicgames.common.server_error'},
              loading: false,
            },
            {deep: true}
          )
        );
      },
      onCancel: () => {
        this.setState(
          this.state.merge(
            {
              loading: false,
            },
            {deep: true}
          )
        );
      },
    });
  }

  onValidateCode(codeData) {
    const {codeInput, isLoggedIn, talonFlowId} = codeData;
    if (isLoggedIn) {
      this.setState(
        this.state.merge({
          redeemCode: codeInput,
          loading: true,
          talonFlowId,
        })
      );
      if (talonFlowId) {
        this.startCaptcha(talonFlowId, this.getInstance().validateCode);
      } else {
        this.getInstance().validateCode();
      }
    } else {
      this.setState(
        this.state.merge({
          currentStage: 'LOGIN',
        })
      );
    }
  }

  onValidateCodeSuccess(response) {
    const newState = {loading: false};
    if (response.data.isSuccess) {
      newState.currentStage = this.state.nextStage;
      newState.isInvalidCode = false;
      newState.title = response.data.data.title;
      newState.description = response.data.data.description;
      newState.entitlementName = response.data.data.entitlementName;
    } else {
      // error handling
      newState.validationError = response.data;
      newState.isInvalidCode = true;
    }
    newState.isCaptachaSolved = response.data.isCaptachaSolved;

    this.setState(this.state.merge(newState));
  }

  onValidateCodeFailure() {
    this.setState(
      this.state.merge({
        isInvalidCode: true,
        loading: false,
      })
    );
  }

  onRedeemCode(data) {
    if (data.isLoggedIn) {
      this.setState(this.state.set('loading', true));
      const callback = () => {
        this.getInstance().redeemCode(data);
      };
      if (this.state.talonFlowId && !this.state.isCaptachaSolved) {
        this.startCaptcha(this.state.talonFlowId, callback);
      } else {
        callback();
      }
    } else {
      this.setState(this.state.set('currentStage', 'LOGIN'));
    }
  }

  onRedeemCodeSuccess(response) {
    if (response.data.isSuccess) {
      this.setState(
        this.state.merge({
          currentStage: this.state.nextStage,
          redeemComplete: true,
          loading: false,
        })
      );
    } else {
      this.setState(
        this.state.merge({
          redeemError: response.data,
          loading: false,
        })
      );
    }
  }

  onRedeemCodeFailure() {
    this.setState(this.state.set('loading', false));
  }

  onClearEntitlementsFromSession() {
    this.getInstance().clearEntitlementsFromSession();
  }

  setNextStage(nextStage) {
    this.setState(this.state.set('nextStage', nextStage));
  }

  setCurrentStage(stage) {
    this.setState(this.state.set('currentStage', stage));
  }

  resetFlow() {
    this.setState(
      this.state.merge({
        currentStage: 'VALIDATE',
        nextStage: '',
        redeemCode: '',
        isInvalidCode: null,
        validationError: null,
        requireEula: false,
        redeemError: null,
        loading: false,
      })
    );
  }

  onRequestLogin(returnPath) {
    const [returnPathname, searchParams] = returnPath?.split('?');
    const redirectURLParams = new URLSearchParams(searchParams || '');

    if (!redirectURLParams.has('lang')) {
      redirectURLParams.set('lang', getLocale());
    }

    const loginUrl = `${root.appContext || ''}/login?${new URLSearchParams({
      lang: getLocale(),
      redirectTo: `${returnPathname ?? root.location.pathname}?${redirectURLParams}`,
    })}`;

    root.location.href = loginUrl;
  }

  onRequestRegister(options) {
    this.onRequestLogin(options);
  }
}

export default alt.createStore(RedeemStore, 'RedeemStore');
